import scDefinitions from '../../../common/config/SelectionCriteriaDefinitions';

class SelectionCriteriaDto {
  constructor(selectionCriteria, scSet, useLabels = false) {
    const ctx = this;
    // ctx.reportCode = selectionCriteria.reportCode;
    ctx.direction = selectionCriteria.direction;
    scSet.forEach((sc) => {
      const scDefinition = scDefinitions[sc];
      const dto = scDefinition.getSelectionCriteriaDto(selectionCriteria, useLabels);
      Object.keys(dto).forEach((key) => {
        ctx[key] = dto[key];
      });
    });
  }
}

export default SelectionCriteriaDto;
